<template>
  <div>
    <div class="row no-gutters">
      <div class="col-3">
        <slot name="day" :day="selectedDay" :updateDay="updateDay"></slot>
      </div>
      <div class="col-6">
        <slot name="month" :month="selectedMonth" :updateMonth="updateMonth"></slot>
      </div>
      <div class="col-3">
        <slot name="year" :year="selectedYear" :updateYear="updateYear"></slot>
      </div>
    </div>
    <Alert v-if="enable && age && age < referenceAge" kind="warning" class="mt-2 p-2 d-block">
      {{ message }}
    </Alert>
  </div>
</template>

<script>
import moment from 'moment'
import Alert from "@/components/ui/Alert.vue";
export default {
  name: "DateSelector",
  components: {Alert},
  props:{
    enable:{
      type: Boolean,
      default: false,
    },
    day:{
      type : Number,
      default : null,
    },
    month:{
      type : Number,
      default : null,
    },
    year:{
      type : Number,
      default : null,
    },
    referenceAge:{
      type: Number,
      default: 0,
    },
    message:{
      type: String,
    },
  },
  data(){
    return {
      selectedDay:this.day,
      selectedMonth: this.month,
      selectedYear:this.year,
    }
  },
  computed:{
    age(){
      if (!this.selectedDay || !this.selectedMonth || !this.selectedYear ){
        return null
      }
      let selectedDate = moment(new Date(this.selectedYear, this.selectedMonth - 1, this.selectedDay)) // January is 0!
      let now = moment(new Date())
      return now.diff(selectedDate, 'years')
    },
  },
  methods:{
    updateDay: function(day){
      this.selectedDay = day
    },
    updateMonth: function(month){
      this.selectedMonth = month
    },
    updateYear: function(year){
      this.selectedYear = year
    },
  },
}
</script>

<style scoped>

</style>
